import { h, Fragment, FunctionalComponent } from 'preact';
import { Properties } from '../../../../common';
import { LocationCodeType } from '../../../../common/types';
import { FinText } from '../../../../i18n';

export interface LocationCodeProps extends Properties {
  type: string;
  locationCode: string;
  enableCompactWidget: boolean;
}

export const LocationCode: FunctionalComponent<LocationCodeProps> = ({ type, locationCode, enableCompactWidget }) => (
  <Fragment>
    {' ('}
    {type === LocationCodeType.AIRPORT || !enableCompactWidget ? (
      <Fragment>{locationCode}</Fragment>
    ) : (
      <FinText id="locationSelector.allAirportsLabel" />
    )}
    {') '}
  </Fragment>
);
